import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "leading-9 ml-1.5 transition-colors hover:text-primary-main" }

import { computed } from "vue";
import { changeCase } from "../../helpers";
import { ElementE } from '../../enums';

interface PropsI {
  name: string,
  title: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TopMenuIcon',
  props: {
    name: {},
    title: {}
  },
  emits: ['click'],
  setup(__props: any) {

const props = __props;




const settings = computed(() => ({
  id: `top-menu-${props.name}`,
  image: require(`./assets/${props.name}.svg`),
  title: props.title,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: settings.value.id,
    class: "flex cursor-pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', props.name)))
  }, [
    _createElementVNode("img", {
      src: settings.value.image,
      alt: "top-menu-item"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(changeCase)(settings.value.title, _unref(ElementE).TITLE)), 1)
  ], 8, _hoisted_1))
}
}

})